import { createAction } from '@'
import { getAuth, loginErrorHandle } from '@misc'
import axios from 'axios'
import { $users } from '../stores'

const ENDPOINT = process.env.REACT_APP_API_URL

export default createAction('GetUsers', async () => {
    try {
        const auth = getAuth()

        const res = await axios({
            url: `${ENDPOINT}/users`,
            method: 'GET',
            headers: { 'Content-Type': 'application/json', ...auth }
        })

        $users.setState(() => (res && res.data) || [])
    } catch (e) {
        loginErrorHandle(e)
        console.error(e)
    }
})
